// mit-Tabs
$('ul.tabs > li > a').attr('data-no-instant', true);
    $('body').on('click', 'ul.tabs > li > a', function(e) {
      e.preventDefault();
      var contentLocation = $(this).attr('href');
      if(contentLocation.charAt(0)=="#") {
        $('ul.tabs > li > a.active').removeClass('active');
        $(this).addClass('active');
        $(this).parents('ul.tabs').next().find(contentLocation).show().css({'display': 'block'}).addClass('active').siblings().hide().removeClass('active');
      }
    });


// ithelps - mk
$(document).ready(function() {

    // CART BUTTON
    document.querySelector(".site-nav__link.site-nav__link--icon.js-drawer-open-cart").addEventListener("click", function() { 
      setTimeout(function(){setDeliveryCostMsg()},1200)  
    }, true);
  
    // TRIGGER CART OR IN/DECREASE QUANTITY
    // other cart class in this new Theme!
    $('body').on('click', 'button.btn.add-to-cart', function() { 
      setTimeout(function(){setDeliveryCostMsg()},2000)  
    })
  
    $('body').on('click', 'button.js-qty__adjust.js-qty__adjust--minus', function() {
      setTimeout(function(){setDeliveryCostMsg()},1200)  
    })
  
    $('body').on('click', 'button.js-qty__adjust.js-qty__adjust--plus', function() {
      setTimeout(function(){setDeliveryCostMsg()},1200)  
    })  
    
    $('body').on('click', '.bundle_apply_discount_block .bundle_apply_discount_text', function () {
        setTimeout(function () { setDeliveryCostMsg() }, 2500)
    })
})

function setDeliveryCostMsg() {

    var priceSum = 0;
    var priceSumRabatt = 0;
    var usePriceSum = 0;

    // GET PRICES
    if($('.cb-bundle-show-ajax_cart__cart_subtotal')[0]){
      priceSum = $('.cb-bundle-show-ajax_cart__cart_subtotal').text().replace('€','').replace(',','');
    }
    
    // GET PRICES-RBATT
    if($('p.priceWithDiscount_cart_drawer')[0]){
      priceSumRabatt = $('p.priceWithDiscount_cart_drawer').text().replace('€','').replace(',','');
    }
    console.log('price/rabatt: ', priceSum, priceSumRabatt);      


    // CHECK WHAT PRICE TO USE
    if(priceSumRabatt != 0) usePriceSum = priceSumRabatt;
    else usePriceSum = priceSum;
    console.log('usePriceSum: ', usePriceSum);      


    // CALC
    var newdeliveryamount = 3000 - usePriceSum;
    console.log('newdeliveryamount: ', newdeliveryamount);


    if(newdeliveryamount <= 0){
      $('.mit-countdown.appear-animation p').text('Glückwunsch, der Versand ist für Sie kostenlos!');
    }
    else {
      // FORMAT PRICE
      var newdeliveryamountTemp = newdeliveryamount / 100;
      newdeliveryamountTemp = newdeliveryamountTemp.toFixed(2)
      var newdeliveryamountString = newdeliveryamountTemp.toString().replace(/\./g, ',');
      console.log('newdeliveryamountString:', newdeliveryamountString);
      
      $('.mit-countdown.appear-animation p').text('Nur noch €' + newdeliveryamountString + ' und der Versand ist für Sie kostenlos!');    
    }
}
